import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, greyMui, redMui, tealMui } from "@ryde/theme";

export const StyledPageWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "controls-page-wrapper",
})`
  padding: 40px 40px;
`;

export const StyledButtonContainer = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "controls-button-container",
})`
  padding-block: 20px;
  padding-inline-start: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 400px;
  h2 {
    color: ${greyMui._600};
    font-size: 17px;
    padding-bottom: 10px;
  }
  button {
    width: fit-content;
    min-width: 200px;
  }
`;

export const CookiesPanelWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "controls-cookies-panel",
})`
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 700px;
  align-items: center;
  margin-top: 30px;
  margin-inline-start: 80px;
  button {
    height: 50px;
    width: 100%;
  }
`;

export const StyledVersionContainer = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "api-version-container",
})`
  display: flex;
  align-items: center;
  gap: 10px;

  .version-label {
    color: ${greyMui._600};
    font-weight: 500;
  }

  .version-value {
    font-weight: 600;
    font-size: 16px;
    padding: 4px 8px;
    background-color: ${blueMui._50};
    border-radius: 4px;
    border: 1px solid ${blueMui._100};
    color: ${blueMui._700};
  }

  .version-value.loading {
    color: ${greyMui._500};
    font-weight: 400;
    font-size: 14px;
    padding: 0;
    background-color: transparent;
    border: none;
  }

  .version-value.error {
    color: ${redMui._700};
    font-weight: 400;
    font-size: 14px;
    padding: 0;
    background-color: transparent;
    border: none;
  }
`;

export const PhoneLinkTestWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "phone-link-test-wrapper",
})`
  width: 300px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 12px;
  border-radius: 4px;
  margin-inline-start: 40px;

  h3 {
    color: ${greyMui._600};
    font-size: 14px;
    font-weight: 500;
    margin: 0 0 8px 0;
  }
`;

export const StyledApiInfoPanel = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "api-info-panel",
})`
  max-width: 560px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 20px;
  border-radius: 8px;
  margin-block-start: 16px;
  margin-inline-start: 40px;
  margin-block-end: 16px;
  background: #fff;

  h2 {
    color: ${greyMui._600};
    font-size: 17px;
    font-weight: 500;
    margin: 0 0 12px 0;
  }
`;

export const StyledEnvFlagsGrid = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "api-env-flags-grid",
})`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;
  font-size: 13px;

  .env-flag-label {
    color: ${greyMui._600};
    font-weight: 500;
  }

  .env-flag-value {
    color: ${greyMui._800};
  }
`;

export const StyledSessionTtlPanel = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "session-ttl-panel",
})`
  max-width: 560px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px 20px;
  border-radius: 8px;
  margin-inline-start: 40px;
  margin-block-end: 16px;
  background: #fff;
  border: 1px solid ${greyMui._200};

  h2 {
    color: ${greyMui._600};
    font-size: 17px;
    font-weight: 500;
    margin: 0 0 12px 0;
  }

  .ttl-meta {
    font-size: 13px;
    color: ${greyMui._600};
    margin-top: 8px;
    line-height: 1.45;
  }

  .ttl-meta--error {
    color: ${redMui._700};
  }

  .ttl-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .ttl-label {
    color: ${greyMui._600};
    font-weight: 500;
  }

  .ttl-value {
    font-weight: 600;
    font-size: 16px;
    padding: 4px 8px;
    background-color: ${tealMui._50};
    border-radius: 4px;
    border: 1px solid ${tealMui._100};
    color: ${tealMui._800};
  }

  .ttl-value.loading {
    color: ${greyMui._500};
    font-weight: 400;
    font-size: 14px;
    padding: 0;
    background-color: transparent;
    border: none;
  }

  .ttl-value.error {
    color: ${redMui._700};
    font-weight: 400;
    font-size: 14px;
    padding: 0;
    background-color: transparent;
    border: none;
  }
`;
